import { useDeliveryZoneMsToken } from 'hooks';
import { GRAPHQL_CLIENT_NAMES } from 'service/constants';
import { apiMutate } from 'service/utils/mutation';
import { assignDriverToOrderMutation } from '../../mutations/verd';

import { UpdateStoreDriverMutationInput } from '../../types/generated';

type useAssignDriverToOrderType = (variables: UpdateStoreDriverMutationInput) => any;

const useAssignDriverToOrder: useAssignDriverToOrderType = () => {
  const deliveryZoneMsToken = useDeliveryZoneMsToken();
  return variables =>
    apiMutate({
      mutation: assignDriverToOrderMutation,
      variables,
      clientName: GRAPHQL_CLIENT_NAMES.VERD,
      requestHeaders: deliveryZoneMsToken ? { token: deliveryZoneMsToken } : {},
      handler: (res: any) => res,
    });
};

export default useAssignDriverToOrder;
